import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
} from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import { useEffect, useState } from "react";
import { AnnouncementService } from "services/menu/announcementService/AnnouncementService";
import { msgTypes } from "constants/msgTypes";
import ApiUrl from "services/shared/ApiUrl";
import { AnnouncementModel } from "model/screensModels/AnnouncementModel";
import "./AnnouncementDisplay.scss";

const AnnouncementDisplay = () => {
  const [announcementData, setAnnouncementData] = useState([]);

  useEffect(() => {
    getAnnouncementLists();
  }, []);

  const getAnnouncementLists = async () => {
    const res = await AnnouncementService.getAnnouncementLists();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      const announcementAllData = res.data.tbody.map((data) => ({
        attachment: ApiUrl.fileBaseUrl + data.attachment,
        title: data.title,
      }));
      setAnnouncementData(announcementAllData);
    }
  };

  const openInTab = async (announcement: AnnouncementModel) => {
    if (announcement.attachment) {
      window.open(announcement.attachment, "_blank");

      const imageURL = await fetch(announcement.attachment);
      const image = await imageURL.blob();
      const url = window.URL.createObjectURL(image);
      const link = document.createElement("a");
      link.href = url;
      link.download = announcement.attachment.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      alert("No Image Is Found From This Attachment");
    }
  };

  return (
    <Box className="announcement-display-main-box">
      <Typography gutterBottom>
        <div className="announcement-display">
          <h6>All Announcements</h6>
        </div>
      </Typography>
      <Card className="announcement-display-data-card">
        <CardContent className="announcement-list-container">
          <List className="announcement-list">
            {announcementData.map((announcement, index) => (
              <ListItem key={index} className="announcements-display-div">
                <ListItemIcon
                  className="announcement-display-data-list-item"
                  onClick={() => openInTab(announcement)}
                >
                  <CampaignIcon />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <a
                      href="#"
                      onClick={() => openInTab(announcement)}
                      className="announcement-display-title"
                    >
                      {announcement.title}
                    </a>
                  }
                />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AnnouncementDisplay;
